import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const PencilStroke48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M29.5977 11.8375C31.159 10.2762 33.6912 10.2749 35.2539 11.8375L36.1396 12.7242C37.7021 14.2855 37.7021 16.8192 36.1396 18.3804L22.9111 31.6099L13.0762 37.3336L10.6445 34.9019L16.3682 25.066L29.5977 11.8375ZM18.1787 26.4615L13.5303 34.4469L21.5156 29.7994L30.7656 20.5484L27.4297 17.2105L18.1787 26.4615ZM29.0342 15.6099L32.4258 19.0025L35.8193 15.6099L32.4258 12.2174L29.0342 15.6099Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
